import {
	GET_UPLOAD_FILE_STATUS_FAILED,
	GET_UPLOAD_FILE_STATUS_REQUEST,
	GET_UPLOAD_FILE_STATUS_RESET,
	GET_UPLOAD_FILE_STATUS_SUCCESS,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_FAILED,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_RESET,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_SUCCESS,
	OPEN_UPLOAD,
	POST_UPLOAD_FILE_FAILED,
	POST_UPLOAD_FILE_REQUEST,
	POST_UPLOAD_FILE_RESET,
	POST_UPLOAD_FILE_SUCCESS,
} from "../types"

const supportedFormats = [
	"pdf",
	"doc",
	"docx",
	"html",
	"htm",
	"pptx",
	"eml",
	"xml",
	"txt",
	"ppt",
	"msg",
	"zip",
	"xlsx",
	"xls",
	//"folder"
	"7z",
	"csv",
	"json",
	"sdt",
	"las",
	"rtf",
	"jpeg",
	"jpg",
	"png",
	"bmp",
	"tiff",
	"gif",
	"webp",
	"svg",
	"ico",
	"mp3",
	"aac",
	"wav",
	"mp4",
	"webm",
	"ogg",
	"psd",
]

const supportedFormatsTooltip = {
	documents: [
		"PDF",
		"DOC",
		"DOCX",
		"HTML",
		"HTM",
		"PPTX",
		"EMAIL",
		"XML",
		"TXT",
		"PPT",
		"MSG",
		"ZIP",
		"XLSX",
		"XLS",
		"FOLDER",
		"ZIP7",
		"CSV",
		"JSON",
		"SDT",
		"LAS",
		"RTF",
	],
	images: ["JPEG", "JPG", "PNG", "BMP", "TIFF", "GIF", "WEBP", "SVG", "ICO"],
	audio: ["MP3", "AAC", "WAV"],
	video: ["MP4", "WEBM", "OGG"],
}

const initialState = {
	isOpen: false,
	supportedFormats: supportedFormats || [],
	supportedFormatsTooltip: supportedFormatsTooltip || {},
	isUploading: false,
	isUploadInprogress: false,
	isLoading: false,
	notifications: [],
}

export default function (state = initialState, action) {
	switch (action.type) {
		case OPEN_UPLOAD:
			return {
				...state,
				isOpen: action?.payload,
			}
		case GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_UPLOAD_SUPPORTED_FILE_FORMAT_SUCCESS:
			const { formats, tooltip } = action.payload
			return {
				...state,
				isLoading: false,
				supportedFormats: formats,
				supportedFormatsTooltip: tooltip,
			}
		case GET_UPLOAD_SUPPORTED_FILE_FORMAT_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
			}
		case GET_UPLOAD_SUPPORTED_FILE_FORMAT_RESET:
			return {
				...state,
				error: undefined,
			}

		case POST_UPLOAD_FILE_REQUEST:
			return {
				...state,
				isUploading: true,
				isOpen: false,
			}
		case POST_UPLOAD_FILE_SUCCESS:
			return {
				...state,
				//isUploading: false,
				isUploadInprogress: true,
			}
		case POST_UPLOAD_FILE_FAILED:
			return {
				...state,
				//isUploading: false,
				error: action.payload,
			}
		case POST_UPLOAD_FILE_RESET:
			return {
				...state,
				error: undefined,
			}
		case GET_UPLOAD_FILE_STATUS_REQUEST:
			return {
				...state,
				//isUploading: true,
				//for demo
				//notifications: [],
			}
		case GET_UPLOAD_FILE_STATUS_SUCCESS:
			//filter the false state
			return {
				...state,
				isUploadInprogress: true,
				notifications: action?.payload,
				isUploading: true,
			}
		case GET_UPLOAD_FILE_STATUS_FAILED:
			return {
				...state,
				isUploading: false,
				error: action?.payload,
				isUploadInprogress: false,
				notifications: [],
			}
		case GET_UPLOAD_FILE_STATUS_RESET:
			return {
				...state,
				error: undefined,
			}
		default:
			return state
	}
}
